import type { FC } from 'react';
import React, { useMemo, useState } from 'react';
import { useTheme } from '@mui/material';

import type { DashboardWidgetConfig } from 'src/types/dashboard';
import GroupedBarChart from 'src/components/dashboard/charts/GroupedBarChart';
import { useStatistics } from 'src/components/dashboard/DashboardContext/StatisticsContext';
import {
  getBarColorMap,
  getGroupData,
  kpiReducer,
} from 'src/components/dashboard/DashboardPage/widgets/GroupedBarWidget/helper';

export interface GroupedBarWidgetProps {
  config: DashboardWidgetConfig;
}

const GroupedBarWidget: FC<GroupedBarWidgetProps> = ({ config }) => {
  const { data } = useStatistics();
  const [groupSelection, setGroupSelection] = useState<string[]>([]);
  const theme = useTheme();
  const { initialData, kpiLabels } = useMemo(() => {
    const historical_data = data?.focal_result.historical_data;
    if (!historical_data) return { initialData: {}, kpiLabels: {} };

    return {
      initialData: historical_data.data || {},
      kpiLabels: historical_data.kpi_labels || {},
    };
  }, [data]);

  const kpiList = useMemo(
    () => kpiReducer(kpiLabels, config.questions),
    [kpiLabels, config.questions],
  );

  const groupData = useMemo(
    () => getGroupData(initialData, groupSelection, kpiList),
    [initialData, groupSelection, kpiList],
  );

  return (
    <GroupedBarChart
      config={config}
      colorMap={getBarColorMap(theme)}
      groupData={groupData}
      kpiList={kpiList}
      groupSelection={groupSelection}
      setGroupSelection={setGroupSelection}
      labels={['KPI 1', 'KPI 2', 'KPI 3']}
      useGradient
    />
  );
};

export default GroupedBarWidget;
